import clsx from 'clsx';
import PropTypes from 'prop-types';
import { memo, useMemo, useRef } from 'react';

import { MatchType } from '../../api/types';
import { useLayoutContext } from '../../context/layout-provider';
import { Carousel, CarouselSlide } from '../carousel/carousel';
import { customizations } from '../market-card/competitors/market-card-competitors.customizations';
import { MarketCard } from '../market-card/market-card';

import { PreloaderTopEvents } from './preloader-top-events';
import { getSliderSettings } from './top-events-utils';

import './top-events.scss';

export function TopEventsUI({ className, matches, isFetched, onCardClick }) {
  const { isWithLeftSidebar, isLeftSidebarCollapsed } = useLayoutContext();
  const carouselRef = useRef();

  const carouselSettings = useMemo(() => getSliderSettings({ isWithLeftSidebar, isLeftSidebarCollapsed }), [
    isWithLeftSidebar,
    isLeftSidebarCollapsed,
  ]);

  const updateDependencies = useMemo(() => [matches], [matches]);

  const { isTeamLogoHidden } = customizations.useCustomizations();

  if (!isFetched) {
    return (
      <div className={clsx('sb-TopEvents', className, isTeamLogoHidden && 'isTeamLogoHidden')}>
        <PreloaderTopEvents />
      </div>
    );
  }
  if (isFetched && matches.length === 0) return null;

  return (
    <div className={clsx('sb-TopEvents', className, isTeamLogoHidden && 'isTeamLogoHidden')}>
      <Carousel
        key={isLeftSidebarCollapsed ? 'collapsed-sidebar-carousel' : 'carousel'}
        ref={carouselRef}
        className="sb-TopEvents-slider"
        updateDependencies={updateDependencies}
        {...carouselSettings}>
        {matches.map(match => (
          <CarouselSlide key={match.matchId}>
            <MarketCard match={match} onCardClick={onCardClick} />
          </CarouselSlide>
        ))}
      </Carousel>
    </div>
  );
}

TopEventsUI.propTypes = {
  className: PropTypes.string,
  matches: PropTypes.arrayOf(MatchType).isRequired,
  isFetched: PropTypes.bool.isRequired,
  onCardClick: PropTypes.func,
};

TopEventsUI.defaultProps = {
  className: undefined,
  onCardClick: undefined,
};

export const TopEvents = memo(TopEventsUI);
